const NoAnimateDirective = function ($animate) {
    return function (scope, element, attrs) {
        $animate.enabled(element, false);
    }
};

NoAnimateDirective.$inject = ["$animate"];

export { NoAnimateDirective };